import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { ConstructionSitePlanningContainer } from 'business/production-and-performance/pages/planning-page/components/construction-site-planning-container';
import { ProdAndPerfFiltersProvider } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';

import { PlanningMobileFilters } from './planning-mobile-filters';

export const PlanningMobilePage = () => {
  const { t } = useTranslation();
  useHead({ title: t('user.menu.sections.prodPerf.planning.title') });

  return (
    <SingleGraphReferenceContextProvider>
      <ProdAndPerfFiltersProvider
        initialFilters={{
          filterType: 'ring',
          ringRange: [null, null],
          dayMode: 'shift',
          withProjection: true,
        }}
      >
        <MobileSingleCardPageWithFilterLayout
          title={t('productionAndPerformance.planning.title')}
          filters={<PlanningMobileFilters />}
        >
          <ConstructionSitePlanningContainer />
        </MobileSingleCardPageWithFilterLayout>
      </ProdAndPerfFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
